module.exports = __webpack_public_path__ + "static/media/postman.6bdd0882.svg";